/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box } from '@rebass/grid';
import { getConfigValue, THEME_CONFIG } from '@amtrav/theme-system';
import { getNavigationLogo } from '@amtrav/view-components';

const MainBackground = styled.div`
  width: 100%;
  min-height: 96px;
  background-color: white;
`;

const LogoWrapper = styled(Box)`
  width: 50%;
  padding: 0px 14px;
  height: 100px;
  max-width: 200px;
  margin-left: 10px;
`;

const HeaderMobile = ({ subheadText = '', homeUrl }) => {
  const navLogoToken = getConfigValue(THEME_CONFIG.navigation.id.logo);
  const NavLogo = () => {
    return getNavigationLogo(navLogoToken);
  };
  return (
    <MainBackground>
      <a href={homeUrl}>
        <LogoWrapper>
          <NavLogo />
        </LogoWrapper>
      </a>
    </MainBackground>
  );
};

HeaderMobile.propTypes = {
  subheadText: PropTypes.string,
  homeUrl: PropTypes.string,
};

export default HeaderMobile;
